import React, {useEffect} from "react";
import {Link} from "gatsby";
import {localeLink} from "../util";

const CookiePopup = ({location, cookiebtn, cookietext1, cookietext2, cookiedata}) => {

    const closePopup = () => {
        let cookie = getCookie("ijob-cookies");
        if (cookie !== "") {

        } else {
            setCookie("ijob-cookies", true, 365);
        }
        document.querySelector(".cookie__outer").classList.add("inactive");
        setTimeout(() => {
            document.querySelector(".cookie__outer").style.display = "none"
        }, 500)
    };

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    useEffect(() => {
        if(getCookie('ijob-cookies') !== ""){
            document.querySelector(".cookie__outer").style.display = "none"
        }
    })

    return (
        <div className="cookie__outer">
            <div className="cookie__inner">
                <p>{cookietext1}<Link to={localeLink('/privacy', location)} className={"underline"}>{cookiedata}</Link>{cookietext2}</p>
                <div className="cookie__btn__container">
                    <div className={"btn btn-cookie"} onClick={() => {closePopup()}}>{cookiebtn}</div>
                </div>
            </div>
        </div>
    )
}
export default CookiePopup
